"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotpCodesReasons = void 0;
const class_validator_1 = require("class-validator");
const Customer_1 = __importDefault(require("./Customer"));
const Resource_1 = __importDefault(require("../Resource"));
const classTransformer_1 = require("../classTransformer");
class TotpCodes extends Resource_1.default {
    constructor() {
        super(...arguments);
        this.created_at = null;
        this.updated_at = null;
        this.reason = null;
        this.expire_at = null;
    }
}
exports.default = TotpCodes;
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], TotpCodes.prototype, "uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, classTransformer_1.Type)(() => Customer_1.default),
    __metadata("design:type", Customer_1.default)
], TotpCodes.prototype, "customer", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], TotpCodes.prototype, "created_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    __metadata("design:type", Object)
], TotpCodes.prototype, "updated_at", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], TotpCodes.prototype, "reason", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], TotpCodes.prototype, "customer_uid", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", String)
], TotpCodes.prototype, "code", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Boolean)
], TotpCodes.prototype, "resent", void 0);
__decorate([
    (0, classTransformer_1.Expose)(),
    __metadata("design:type", Object)
], TotpCodes.prototype, "expire_at", void 0);
var TotpCodesReasons;
(function (TotpCodesReasons) {
    TotpCodesReasons["LOGIN"] = "LOGIN";
    TotpCodesReasons["RESET_PASSWORD"] = "RESET_PASSWORD";
    TotpCodesReasons["FIRST_LOGIN"] = "FIRST_LOGIN";
})(TotpCodesReasons || (exports.TotpCodesReasons = TotpCodesReasons = {}));
